import React,{ useState, useEffect, useCallback } from "react";
import { 
    Button,
    Form,
    Input,
    notification,
    Checkbox,
    Alert
} from 'antd';
import axios from 'axios';
import MaskedInput from "antd-mask-input";
import {
    useGoogleReCaptcha
} from 'react-google-recaptcha-v3';

import { 
    CheckCircleOutlined,
    CloseCircleOutlined,
    FrownOutlined
} from '@ant-design/icons';

function PaymentDetails( {
        cartTotal,
        cartHasItems,
        setCartHasItems,
        serviceAddressComponentCompleted,
        contactInfoComponentCompleted,
        activationComponentCompleted,
        setPaymentComponentCompleted,
        paymentComponentCompleted,
        setPaymentReceived,
        paymentIsProcessing,
        setPaymentIsProcessing,
        paymentReceived,
        setOrderConfirmationNumber,
        isD2C,
        handleEmailOrderToCustomer,
        d2cOrderComplete,
        doIncludeAmazonCard,
        setDoIncludeAmazonCard,
        qualificationObject,
        setIsNearNet,
        isNearNet,
        setHasFibreUpgradeAgrement,
        hasFibreUpgradeAgrement
    } ) {

    const [cardNumberValidSuffix, setCardNumberValidSuffix] = useState(<></>);
    const [cardNameValidSuffix, setCardNameValidSuffix] = useState(<></>);
    const [cardLastNameValidSuffix, setCardLastNameValidSuffix] = useState(<></>);
    const [cardExpValidSuffix, setCardExpValidSuffix] = useState(<></>);
    const [cardCVVValidSuffix, setCardCVVValidSuffix] = useState(<></>);
    const [cardPostalValidSuffix, setCardPostalValidSuffix] = useState(<></>);
    const [canViewPaymentDetails, setCanViewPaymentDetails] = useState( false );
    const [showPlaceOrder, setShowPlaceOrder] = useState( 'none' );
    const [showEmailOrder, setShowEmailOrder] = useState( 'none' );
    const [cardNumber, setCardNumber] = useState(null);
    const [cardNumberValid, setCardNumberValid] = useState(false);
    const [cardName, setCardName] = useState('');
    const [cardNameValid, setCardNameValid] = useState(false);
    const [cardLastName, setCardLastName] = useState('');
    const [cardLastNameValid, setCardLastNameValid] = useState(false);
    const [cardExp, setCardExp] = useState(null);
    const [cardExpValid, setCardExpValid] = useState(false);
    const [cardCVV, setCardCVV] = useState(null);
    const [cardCVVValid, setCardCVVValid] = useState(false);
    const [cardPostal, setCardPostal] = useState(null);
    const [cardPostalValid, setCardPostalValid] = useState(false);
    const [alertMarkup, setAlertMarkup] = useState(<></>);
    const [postPaymentDetailMarkup, setPostPaymentDetailMarkup] = useState(<></>);
    const [TELUSServicesDisclaimer, setTELUSServicesDisclaimer] = useState(false);
    const [canPassTELUSServiceDisclaimer, setCanPassTELUSServiceDisclaimer] = useState(true);
    const siteDomain = headerVars.siteDomain;
    const { executeRecaptcha } = useGoogleReCaptcha();
    const [api, contextHolder] = notification.useNotification();
    const url_string = window.location.href;
    const url = new URL(url_string);
    const displayCart = url.searchParams.get("show-cart");

    useEffect(() => {
        //console.log('cardNumberValid: ', cardNumberValid);
        //console.log('cardNameValid: ', cardNameValid);
        //console.log('cardExpValid: ', cardExpValid);
        //console.log('cardCVVValid: ', cardCVVValid);
        //console.log('cartTotal: ', cartTotal);

        //console.log('contactInfoComponentCompleted: ', //contactInfoComponentCompleted);
        //console.log('serviceAddressComponentCompleted: ', serviceAddressComponentCompleted);
        //console.log('activationComponentCompleted: ', activationComponentCompleted);

        //console.log('displayCart: ', displayCart);
        //console.log('TELUSServicesDisclaimer: ', TELUSServicesDisclaimer);
        //console.log('qualificationObject: ', qualificationObject);

        if( displayCart ) {
            if( TELUSServicesDisclaimer ) {
                setCanPassTELUSServiceDisclaimer( true );
            } else {
                setCanPassTELUSServiceDisclaimer( false );
            }
        } else {
            setCanPassTELUSServiceDisclaimer( true );
        }
        
        if( cartHasItems &&
            contactInfoComponentCompleted &&
            serviceAddressComponentCompleted &&
            !paymentReceived &&
            !isD2C &&
            activationComponentCompleted ) {
                setCanViewPaymentDetails( true );
                setShowPlaceOrder( 'block' );
        } else {
            setCanViewPaymentDetails( false );
            setShowPlaceOrder( 'none' );
        }

        let nearFibreNetwork = false;
        if( isD2C ) {
            if( qualificationObject != '' ) {
                if( qualificationObject.services.length ) {
                    for( let i=0; i < qualificationObject.services.length; i++ ) {
                        if( qualificationObject.services[i].service.action == 'connect' ) {
                            nearFibreNetwork = true;
                        }
                    }
                } 
            }
        }
        setIsNearNet( nearFibreNetwork );
    },[ 
        contactInfoComponentCompleted, 
        serviceAddressComponentCompleted, 
        activationComponentCompleted,
        cartHasItems, 
        isD2C,
        cardNumberValid,
        cardNameValid,
        cardLastName,
        cardExpValid,
        cardCVVValid,
        cardPostalValid,
        TELUSServicesDisclaimer,
        isNearNet
    ])

    const handleReCaptchaVerify = useCallback(async () => {
        if (!executeRecaptcha) {
          console.log('Execute recaptcha not yet available');
          return;
        }
    
        const token = await executeRecaptcha('success');
        //console.log("token: ", token);

        initiateCheckoutXML( token )

    }, [
        executeRecaptcha,
        cardNumber,
        cardName,
        cardLastName,
        cardExp,
        cardCVV,
        cardPostal,
        cartTotal

    ]);

    function initiateCheckoutXML( token ) {
        var card = formatCardData( cardNumber, 'cardNum');
        var exp = formatCardData( cardExp, 'exp' );
        var cvv = cardCVV;
        var postal = cardPostal;
        var gettoken = "y";
        var addtoken = "y";
        var firstname = cardName;
        var lastname = cardLastName;
        var amount = cartTotal;
        var recaptchaToken = token;

        setPaymentIsProcessing( true );
        setAlertMarkup(<></>);

        var paymentData = {
            ssl_card_number: card,
            ssl_exp_date: exp,
            ssl_get_token: gettoken,
            ssl_add_token: addtoken,
            ssl_first_name: firstname,
            ssl_last_name: lastname,
            ssl_cvv2cvc2: cvv,
            ssl_avs_zip: postal,
            ssl_amount: amount,
            current_environment: headerVars.currentEnvironment,
            recaptcha_token: recaptchaToken
        };

        //console.log('paymentData: ', paymentData);

        var path = headerVars.themeURI+"/inc/converge-checkoutxml.php";

        var headers = { 'Content-type' : 'application/json, text/plain' };

        //console.log("path:: ", path);

        axios
        .post(path, paymentData)
        .then(function(response){
            //console.log("response:::", response.data);
            let verificationResult = jQuery(response.data).find('ssl_result_message').text();
            let maskedCardNumber = '';
            let cardType = '';
            let cardExp = '';
            let cardToken = '';
            let approvalCode = '';
            let errorMessage = ''; 

            //verificationResult = 'APPROVAL';

            if( verificationResult == 'APPROVAL' ) {
                maskedCardNumber = jQuery(response.data).find('ssl_card_number').text();
                cardType = jQuery(response.data).find('ssl_card_short_description').text();
                cardExp = jQuery(response.data).find('ssl_exp_date').text();
                cardToken = jQuery(response.data).find('ssl_token').text();
                approvalCode = jQuery(response.data).find('ssl_approval_code').text();
                
                //console.log("Approval Code=" + approvalCode);
                //maskedCardNumber = '************8956';
                //cardType = 'VISA';
                //cardExp = '02/32';
                //cardToken = '6546541321321654654';
                //approvalCode = '56231231';

                setPostPaymentDetailMarkup(
                    <>
                        <div className="payment-detail">
                            <span>Card number: </span><span>{ maskedCardNumber }</span>
                        </div>
                        <div className="payment-detail">
                            <span>Card type: </span><span>{ cardType }</span>
                        </div>
                        <div className="payment-detail">
                            <span>Card exp: </span><span>{ cardExp }</span>
                        </div>
                        <div className="payment-detail">
                            <span>Approval code: </span><span>{ approvalCode }</span>
                        </div>
                    </>
                );
                getOrderDataObj(approvalCode, maskedCardNumber, cardType, cardExp, cardToken);

            } else {
                errorMessage = jQuery(response.data).find('errorMessage').text();
                setPaymentIsProcessing( false );

                if( response.data == 'Card number is invalid' ) {
                    openNotification('top', 'invalid-card-number', response.data);
                    setAlertMarkup( 
                        <Alert 
                            message="Payment Declined:" 
                            description={ response.data }
                            type="error" 
                            showIcon 
                            closable
                        />
                    );
                } else if( response.data == 'using-proxy' ){
                    errorMessage = 'Please turn off your proxy or VPN and try again.';
                    openNotification('top', 'merchant-api-error-response', errorMessage);
                    setAlertMarkup( 
                        <Alert 
                            message="You seem to be using a proxy or VPN:" 
                            description={ "Please turn off your proxy or VPN and try again." }
                            type="error" 
                            showIcon 
                            closable
                        />
                    );
                } else if( errorMessage != '' ){
                    errorMessage = jQuery(response.data).find('errorMessage').text();
                    openNotification('top', 'merchant-api-error-response', errorMessage);
                    setAlertMarkup( 
                        <Alert 
                            message="Payment Declined:" 
                            description={ errorMessage }
                            type="error" 
                            showIcon 
                            closable
                        />
                    );
                } else {
                    openNotification('top', 'generic-error');
                    setAlertMarkup( 
                        <Alert 
                            message="Payment Declined:" 
                            description="Please check your card information and try again."
                            type="error" 
                            showIcon 
                            closable
                        />
                    );
                }
            }
        })
        .catch(function (error) {
            console.log(error);
            openNotification('top', 'generic-error');
            setPaymentIsProcessing( false );
            setAlertMarkup( 
                <Alert 
                    message="Sorry, we are unable to process your request:" 
                    description={<p>Please give us a call at 1-866-434-5888 and we'll be happy and help. Typical wait times are 2 minutes.</p>}
                    type="error" 
                    showIcon 
                    closable
                />
            );
        })
        .finally(function () {
            // always executed 
        }); 
        return false;
    }

    const openNotification = ( placement, messageId='', responseMsg ) => {
        switch( messageId ) {
            case 'invalid-card-number': 
            api.info({
                message: "Payment Declined:",
                description: responseMsg,
                placement,
                icon: (
                    <FrownOutlined
                      style={{
                        color: '#d42d27',
                      }}
                    />
                ),
            });
            break;
            case 'merchant-api-error-response': 
            api.info({
                message: "Payment Declined:",
                description: responseMsg,
                placement,
                icon: (
                    <FrownOutlined
                      style={{
                        color: '#d42d27',
                      }}
                    />
                ),
            });
            break;
            case '': 
            api.info({
                message: "Payment Declined:",
                description: "Please check your card information and try again.",
                placement,
                icon: (
                    <FrownOutlined
                      style={{
                        color: '#d42d27',
                      }}
                    />
                ),
            });
            break;
        }
    }

    function getOrderDataObj( 
        approvalCode, 
        cardNum, 
        cardType, 
        cardExp, 
        cardToken ) {
        let requestUrl = {ajax_url : siteDomain+"/wp-admin/admin-ajax.php"};
        let form_data = new FormData;
        
        form_data.append('action', 'startca_handle_create_order_after_payment_authorized');
        form_data.append('card_num', cardNum );
        form_data.append('card_type', cardType );
        form_data.append('card_exp', cardExp );
        form_data.append('card_token', cardToken );
        form_data.append('approval_code', approvalCode );

        axios
        .post(requestUrl.ajax_url, form_data)
        .then(function(response){
            console.log(response.data);
            if( cardToken == '' || cardToken == null || cardToken == undefined) {
                console.log('card token invalid');
            } else {
                //location.href = "/signup/success";
                console.log('payment received');
                setPaymentReceived( true );
                setOrderConfirmationNumber( approvalCode );
                setPaymentIsProcessing( false );
                //document.dispatchEvent(new CustomEvent('cartUpdateState', { detail: '' }));
                //setCartHasItems( false );
            }
        })
        .catch(function (error) {
            console.log(error);
            setPaymentIsProcessing( false );
        })
        .finally(function () {
            // always executed 
        }); 
    }

    const formatCardData = ( data, input ) => {
        switch( input ) {
            case 'cardNum':
            var str = data.replace(/\s/g, '');
            return str;
            
            case 'exp': 
            var str = data.replace(/\s/g, '').replace(/\//g, '');
            return str;
        }
    }

    const handleOnInputChange = ( e ) => {
        let currentVal = e.target.value;
        let inputID = e.target.id;
        validateInput( currentVal, inputID );

        if( 
            !cardNumberValid || 
            !cardNameValid || 
            !cardExpValid || 
            !cardCVVValid || 
            !cardPostalValid
            ) {
            setPaymentComponentCompleted(false);
        }
    }

    const validateInput = ( currentVal, inputId ) => {
        let isValid = true;
        let validationSuffix = <></>;

        switch( inputId ) {
            case 'creditnumber':
                let cleanCardNumber = currentVal.replace(/\s/g, '');

                if( !cleanCardNumber.match(/^\d{16}$/) ) {
                    isValid = false;
                }

                validationSuffix = isValid ? <CheckCircleOutlined style={{ color: '#52C41A' }}/> : <CloseCircleOutlined style={{ color: '#ff4545' }}/>;

                setCardNumberValidSuffix( validationSuffix );

                let cardNumber = isValid ? cleanCardNumber : null;
                setCardNumber( cardNumber );
                setCardNumberValid( isValid );
            break;

            case 'creditName':
                if( currentVal.length < 2 ) {
                    isValid = false;
                }

                validationSuffix = isValid ? <CheckCircleOutlined style={{ color: '#52C41A' }}/> : <CloseCircleOutlined style={{ color: '#ff4545' }}/>;

                setCardNameValidSuffix( validationSuffix );

                let cardName = isValid ? currentVal : '';
                setCardName( cardName );
                setCardNameValid( isValid );
            break;

            case 'creditLastName':
                if( currentVal.length < 2 ) {
                    isValid = false;
                }

                validationSuffix = isValid ? <CheckCircleOutlined style={{ color: '#52C41A' }}/> : <CloseCircleOutlined style={{ color: '#ff4545' }}/>;

                setCardLastNameValidSuffix( validationSuffix );

                let cardLastName = isValid ? currentVal : '';
                setCardLastName( cardLastName );
                setCardLastNameValid( isValid );
            break;

            case 'creditExpMonth':
                if( !currentVal.match(/^(0[1-9]|1[0-2])\/?([0-9]{4}|[0-9]{2})$/) ) {
                    isValid = false;
                }

                validationSuffix = isValid ? <CheckCircleOutlined style={{ color: '#52C41A' }}/> : <CloseCircleOutlined style={{ color: '#ff4545' }}/>;

                setCardExpValidSuffix( validationSuffix );

                let cardExp = isValid ? currentVal : '';
                setCardExp( cardExp );
                setCardExpValid( isValid );
            break;

            case 'creditCVV':
                if( !currentVal.match(/^[0-9]{3,4}$/) ) {
                    isValid = false;
                }

                validationSuffix = isValid ? <CheckCircleOutlined style={{ color: '#52C41A' }}/> : <CloseCircleOutlined style={{ color: '#ff4545' }}/>;

                setCardCVVValidSuffix( validationSuffix );

                let cardCVV = isValid ? currentVal : '';
                setCardCVV( cardCVV );
                setCardCVVValid( isValid );
            break;

            case 'creditPostal':
                if( currentVal.length < 5 ) {
                    isValid = false;
                }

                validationSuffix = isValid ? <CheckCircleOutlined style={{ color: '#52C41A' }}/> : <CloseCircleOutlined style={{ color: '#ff4545' }}/>;

                setCardPostalValidSuffix( validationSuffix );

                let cardPostal = isValid ? currentVal : '';
                setCardPostal( cardPostal );
                setCardPostalValid( isValid );
            break;
        }
    }

    const getPaymentDetailsMarkup = () => {
        let serviceManagementDisclaimer = <></>;

        if( paymentReceived ) {
            return (
                <div className={ "post-payment-details" }>
                    { postPaymentDetailMarkup }
                </div>
            );
        } else if( canViewPaymentDetails ) {

            if( displayCart ) {
                serviceManagementDisclaimer = 
                    <div className="form-column-row">
                        <Checkbox
                            style={{ padding:'5px', borderRadius: '8px', marginBottom: '1rem', width:'fit-content', display:( activationComponentCompleted ) ? 'inline-flex':'none' }}
                            id="services-disclaimer"
                            onChange={ onDisclaimerCheckboxChange }
                            //checked={ canContactCustomer }
                        >
                            I understand Start.ca services, TELUS Home Security and Koodo Mobility are invoiced seperately and managed by different support teams.
                        </Checkbox>
                    </div>
            }

            return (
                <Form>
                    <div className="form-column-row">
                        <Form.Item
                            label="Card number"
                            labelCol={{ span: 24 }}
                            style={{ 'width': '100%' }}
                            name="creditnumber"
                            rules={[
                                {
                                required: true,
                                message: 'Please input your card number!',
                                },
                            ]}
                        >
                            <MaskedInput
                                id="creditnumber"
                                mask={'0000 0000 0000 0000'}
                                suffix={ cardNumberValidSuffix }
                                onChange={handleOnInputChange}
                                defaultValue={ cardNumber }
                            />
                        </Form.Item>
                        <Form.Item
                            label="Expiration Date"
                            labelCol={{ span: 24 }}
                            style={{ 'width': '100%' }}
                            className='inline-form-item'
                            name="creditExpMonth"
                            rules={[
                                {
                                required: true,
                                message: 'Please input your card number!',
                                },
                            ]}
                        >
                            <MaskedInput
                                id="creditExpMonth"
                                mask={'00/00'}
                                suffix={ cardExpValidSuffix }
                                onChange={handleOnInputChange}
                                defaultValue={ cardExp }
                            />
                        </Form.Item>
                    </div>
    
                    <div className="form-column-row">
                        <Form.Item
                            label="Card holder first name"
                            labelCol={{ span: 24 }}
                            style={{ 'width': '100%' }}
                            name="creditName"
                            rules={[
                                {
                                required: true,
                                message: 'Please input your name as it appears on the card!',
                                },
                            ]}
                        >
                            <Input
                                id="creditName"
                                className="creditname cc-input-field"
                                suffix={ cardNameValidSuffix }
                                onChange={handleOnInputChange}
                                defaultValue={ cardName }
                            />
                        </Form.Item>
                        <Form.Item
                            label="Card holder last name"
                            labelCol={{ span: 24 }}
                            style={{ 'width': '100%'}}
                            className='inline-form-item'
                            name="creditLastName"
                            rules={[
                                {
                                required: true,
                                message: 'Please input your name as it appears on the card!',
                                },
                            ]}
                        >
                            <Input
                                id="creditLastName"
                                className="creditname cc-input-field"
                                suffix={ cardLastNameValidSuffix }
                                onChange={handleOnInputChange}
                                defaultValue={ cardLastName }
                            />
                        </Form.Item>
                    </div>

                    <div className="form-column-row">
                        <Form.Item
                            label="CVC"
                            labelCol={{ span: 24 }}
                            style={{ 'width': '100%' }}
                            name="creditCVV"
                            className="card-cvv-field"
                            rules={[
                                {
                                required: true,
                                message: 'Please input your cards CVV number!',
                                },
                            ]}
                        >
                            <MaskedInput
                                id="creditCVV"
                                mask={'000'}
                                suffix={ cardCVVValidSuffix }
                                onChange={handleOnInputChange}
                                defaultValue={ cardCVV }
                            />
                        </Form.Item>
                        <Form.Item
                            label="Card holder postal/zip"
                            labelCol={{ span: 24 }}
                            style={{ 'width': '100%' }}
                            className='inline-form-item'
                            name="creditPostal"
                            rules={[
                                {
                                required: true,
                                message: 'Please input the postal/zip code associated with this card!',
                                },
                            ]}
                        >
                            <Input
                                id="creditPostal"
                                className="creditname cc-input-field"
                                suffix={ cardPostalValidSuffix }
                                onChange={handleOnInputChange}
                                defaultValue={ cardPostal }
                            />
                        </Form.Item>
                    </div>
                    { serviceManagementDisclaimer }
                </Form>
            )
        } else {
            return( <></> )
        }
    }

    const onDisclaimerCheckboxChange = ( e ) => {
        let checked = e.target.checked;
        //console.log( "checked: ", checked );
        setTELUSServicesDisclaimer(checked);
    }

    const onCheckboxChange = ( e ) => {
        let checked = e.target.checked;
        //console.log( "checked: ", checked );
        setDoIncludeAmazonCard(checked);
    }

    const onRequestFibreCheckboxChange = ( e ) => {
        let checked = e.target.checked;
        //console.log( "checked: ", checked );
        setHasFibreUpgradeAgrement(checked);
    }

    return ( 
        <div className="configuration-container config-section-container">
            <div className="contact-info-folded">
                <hr />
                
                <div className="configuration-header-container">
                    <div className="configuration-header">
                        Payment Details
                    </div>
                    
                    <div className="component-update-link" style={{"display": 'none'}}>
                        <Button type="link" class="change-info-button internet-package-check-availability-button" onClick={ ''}>Change</Button>
                    </div>
                </div>
                { getPaymentDetailsMarkup() }
                <div style={{ 'marginTop':'1rem', 'marginBottom':'1.5rem' }}>
                    { alertMarkup }
                </div>
                <Button 
                    onClick={ handleReCaptchaVerify }
                    type="primary"
                    loading={ paymentIsProcessing }
                    disabled={ ( 
                        cardNumberValid &&
                        cardNameValid && 
                        cardLastNameValid &&
                        cardExpValid && 
                        cardCVVValid &&
                        cardPostalValid &&
                        canPassTELUSServiceDisclaimer &&
                        !paymentReceived
                    ) ? false : true }
                    style={ { "margin":'1rem 0', "display": showPlaceOrder, "width": '100%' } }
                >Buy Now</Button>

                {/* <div className="form-column-row">
                    <Checkbox
                        style={{ padding:'5px', borderRadius: '8px', marginBottom: '1rem', width:'fit-content', display:( isD2C && activationComponentCompleted ) ? 'inline-flex':'none' }}
                        id="az-promo"
                        onChange={ onCheckboxChange }
                        //checked={ canContactCustomer }
                    >
                        Gift card included.
                    </Checkbox>
                </div> */}

                <div className="form-column-row">
                    <Checkbox
                        style={{ padding:'5px', borderRadius: '8px', marginBottom: '1rem', width:'fit-content', display:( isD2C && activationComponentCompleted && isNearNet ) ? 'inline-flex':'none' }}
                        id="fibre-upgrade-request"
                        onChange={ onRequestFibreCheckboxChange }
                        //checked={ canContactCustomer }
                    >
                        Customer requests fibre upgrade pending availability.
                    </Checkbox>
                </div>

                <Button 
                    onClick={ handleEmailOrderToCustomer }
                    type="primary"
                    loading={ paymentIsProcessing }
                    style={ { "margin":'1rem 0', "display": ( isD2C && activationComponentCompleted )  ? 'block' : 'none', "width": '100%' } }
                >Email order to customer</Button>
            </div>
            { contextHolder }
        </div>
    )
}

export default PaymentDetails